import React from "react";

import { Redirect, Route } from "react-router";
import { Switch } from "react-router-dom";

import {
  AirlinesPage,
  AirlinesProductivityPage,
  AlertsPage,
  AuctionPage,
  BookingsPage,
  Clicks,
  ContactPage,
  Conversions,
  DashboardPage,
  DebugPage,
  ExtendedReportForm,
  FAQArticlePage,
  FAQCategoriesPage,
  FAQContainer,
  FeedbacksPage,
  GateTesterPage,
  HostsPage,
  IntegrationErrorsPage,
  ReportsPage,
  RoutesPage,
} from "../pages";
import {
  VIEW_AIRLINES_PAGE_PERM,
  VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM,
  VIEW_ALERTS_PAGE_PERM,
  VIEW_AUCTION_PAGE_PERM,
  VIEW_BOOKINGS_PAGE_PERM,
  VIEW_CLICKS_PAGE_PERM,
  VIEW_CONTACT_US_PAGE_PERM,
  VIEW_CONVERSIONS_PAGE_PERM,
  VIEW_DASHBOARD_PAGE_PERM,
  VIEW_DEBUG_PAGE_PERM,
  VIEW_DIRECTIONS_PAGE_PERM,
  VIEW_ERRORS_PAGE_PERM,
  VIEW_FAQ_PAGE_PERM,
  VIEW_FEEDBACKS_PAGE_PERM,
  VIEW_GATE_TESTER_PAGE_PERM,
  VIEW_HOSTS_PAGE_PERM,
  VIEW_REPORTS_PAGE_PERM,
} from "../permissions";

import { PermissionRoute } from "./private_route";
import { AdminRoute, ApplicationRoute, UserRoute } from "./routes";

export const FAQRoutesList: React.FC = () => {
  return (
    <FAQContainer>
      <Switch>
        <PermissionRoute
          exact
          path={UserRoute.FAQCategories}
          component={FAQCategoriesPage}
          permissions={[VIEW_FAQ_PAGE_PERM]}
        />
        <PermissionRoute
          exact
          path={UserRoute.FAQArticle}
          component={FAQArticlePage}
          permissions={[VIEW_FAQ_PAGE_PERM]}
        />
      </Switch>
    </FAQContainer>
  );
};

export const UserRoutesList: React.FC = () => {
  return (
    <Switch>
      <PermissionRoute
        exact
        path={UserRoute.Dashboard}
        component={DashboardPage}
        permissions={[VIEW_DASHBOARD_PAGE_PERM]}
      />
      <PermissionRoute
        exact
        path={UserRoute.Conversions}
        component={Conversions}
        permissions={[VIEW_CONVERSIONS_PAGE_PERM]}
      />
      <PermissionRoute exact path={UserRoute.Clicks} component={Clicks} permissions={[VIEW_CLICKS_PAGE_PERM]} />
      <PermissionRoute
        exact
        path={UserRoute.Bookings}
        component={BookingsPage}
        permissions={[VIEW_BOOKINGS_PAGE_PERM]}
      />
      <PermissionRoute exact path={UserRoute.Auction} component={AuctionPage} permissions={[VIEW_AUCTION_PAGE_PERM]} />
      <PermissionRoute exact path={UserRoute.Hosts} component={HostsPage} permissions={[VIEW_HOSTS_PAGE_PERM]} />
      <PermissionRoute
        exact
        path={UserRoute.Directions}
        component={RoutesPage}
        permissions={[VIEW_DIRECTIONS_PAGE_PERM]}
      />
      <PermissionRoute
        exact
        path={UserRoute.Airlines}
        component={AirlinesPage}
        permissions={[VIEW_AIRLINES_PAGE_PERM]}
      />
      <PermissionRoute
        exact
        path={UserRoute.AirlinesProductivity}
        component={AirlinesProductivityPage}
        permissions={[VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM]}
      />
      <PermissionRoute exact path={UserRoute.Alerts} component={AlertsPage} permissions={[VIEW_ALERTS_PAGE_PERM]} />
      <PermissionRoute exact path={UserRoute.Debug} component={DebugPage} permissions={[VIEW_DEBUG_PAGE_PERM]} />
      <PermissionRoute
        exact
        path={UserRoute.GateTester}
        component={GateTesterPage}
        permissions={[VIEW_GATE_TESTER_PAGE_PERM]}
      />
      <PermissionRoute
        exact
        path={UserRoute.Contact}
        component={ContactPage}
        permissions={[VIEW_CONTACT_US_PAGE_PERM]}
      />
      <PermissionRoute exact path={UserRoute.Reports} component={ReportsPage} permissions={[VIEW_REPORTS_PAGE_PERM]} />
      <PermissionRoute
        exact
        path={UserRoute.ExtendedReport}
        component={ExtendedReportForm}
        permissions={[VIEW_DASHBOARD_PAGE_PERM]}
      />
      <PermissionRoute
        exact
        path={UserRoute.Feedbacks}
        component={FeedbacksPage}
        permissions={[VIEW_FEEDBACKS_PAGE_PERM]}
      />
      <PermissionRoute
        exact
        path={UserRoute.Errors}
        component={IntegrationErrorsPage}
        permissions={[VIEW_ERRORS_PAGE_PERM]}
      />
      <PermissionRoute path={UserRoute.FAQCategories} component={FAQRoutesList} permissions={[VIEW_FAQ_PAGE_PERM]} />
      <Redirect to={ApplicationRoute.NotFound} />
    </Switch>
  );
};

export const AdminRoutesList: React.FC = () => {
  return (
    <Switch>
      <Route exact path={AdminRoute.Panel} component={DashboardPage} />
      <Redirect to={ApplicationRoute.NotFound} />
    </Switch>
  );
};
